<template>
  <div>
    <div class="format">
      <h2>numberFormat(comma)</h2>
      <el-input v-model="value" v-comma :maxlength="length" placeholder="금액을 입력하시오"></el-input><br><br><br>
    </div>
    <div class="format">
      <span>최대길이</span>
      <el-input v-model="length"></el-input>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      value:null,
      price:null,
      length:10
    }
  }
}
</script>
<style lang="scss" scoped>
.format{
  width:200px;
}
</style>
